import BookingReducer from './booking_reducer';

export default BookingReducer;
